/**
 * 정산관리(통합원장) API 호출 모듈.
 * axios 인스턴스(src/api/index.js)를 공통으로 사용하며,
 * 인증 토큰은 index.js 인터셉터에서 자동으로 Authorization 헤더에 주입된다.
 *
 * 권한:
 * - HQ 관리자: 전체 조회
 * - 지점 관리자: rec_branch_code 또는 use_branch_code = 내 지점코드인 건만 (서버에서 자동 필터링)
 */
import api from './index'

/* ================================================================
 * 정산관리(통합원장) API
 * ================================================================ */

/**
 * 통합원장 목록 조회 (페이지네이션 + 검색 필터).
 * 거래유형(P2P_ASK/PRODUCT_BUY) 구분 없이 전체 원장을 조회한다.
 *
 * @param {Object} params - { tradeKind, spotType, keyword, startDate, endDate, page, size }
 *   - tradeKind: 'P2P_ASK' | 'PRODUCT_BUY' | '' (전체)
 *   - spotType: 'GOLD' | 'SILVER' | '' (전체)
 *   - keyword: 원장코드, 결제코드, 회원명 등 ILIKE 검색
 * @returns {Promise} { code, message, data: { items, total, page, size, totalPages } }
 */
export function getSettlementList(params) {
  return api.get('/api/v1/trade-unified-ledger', { params })
}

/**
 * 통합원장 상세 조회.
 * 수수료 전체(본사·이용지점·추천지점), 연결 코드, 인출 정보 등 전체 필드를 반환한다.
 * 지점 관리자가 권한 없는 건을 조회하면 NOT_FOUND 응답.
 *
 * @param {string} tradeUnifiedLedgerCode - 원장코드
 * @returns {Promise} { code, message, data: { ...전체원장정보 } }
 */
export function getSettlementDetail(tradeUnifiedLedgerCode) {
  return api.get(`/api/v1/trade-unified-ledger/${tradeUnifiedLedgerCode}`)
}
